const Footer = () =>{
    return(
        <div>

<footer className="footer-section">
			<div className="container-fluid">

				
			
            <section className="row mt-5">
        <div className="col-12 col-md-4 mt-5">
          <h2 className="mb-3">About Food</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe pariatur reprehenderit vero atque,
            consequatur id ratione, et non dignissimos culpa? Ut veritatis, quos illum totam quis blanditiis, minima
            minus odio!</p>
        </div>
        <div className="col-12 col-md-4 mt-5">
          <h2 className="mb-3">Navigations</h2>
          <div className="row">
            <div className="col-6">
              <a href="#" className="navi">Home</a>
            </div>


          
          </div>
          <div className="row">
            <div className="col-6">
              <a href="#" className="navi">Services</a>
            </div>


           
          </div>
          <div className="row">
            <div className="col-6">
              <a href="#" className="navi">About Us</a>
            </div>


          
          </div>
          <div className="row">

            <div className="col-6">
              <a href="#" className="navi">Contact Us</a>
            </div>


           
          </div>


        </div>
        <div className="col-12 col-md-4 mt-5">
          <h2 className="mb-3">Contact Us</h2>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit minima minus odio.</p>
          <div className="input-group mb-3">
            <input type="text" className="form-control" placeholder="Enter Email" aria-label="Enter Email"
              aria-describedby="basic-addon2"/>
            <span className="input-group-text send" id="basic-addon2">Send</span>
          </div>


        </div>

        

        <div className="col-12 text-center mt-4">
          <p className="mt-2 me-5">&copy;Copyright | All rights reserved <span><i
                className="far fa-heart"></i></span> by Mansi Nimbalkar


          </p>
        </div>
      </section>


			</div>
		</footer>
        </div>
    )
}

export default Footer;